import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import classNames from 'classnames'
import { ReactElement, ReactNode } from 'react'
import { Badge, IconFa, Text, TextProps } from '../../atoms'

export function SectionAccordion({
  title,
  children,
  border,
  activeFilters,
  defaultOpen,
  icon,
  className,
  titleOptions
}: {
  title: string
  children: ReactNode
  border?: boolean
  activeFilters: number
  defaultOpen?: boolean
  icon?: ReactNode
  className?: string
  titleOptions?: Omit<TextProps, 'children'>
}): ReactElement {
  return (
    <Disclosure defaultOpen={defaultOpen}>
      {({ open }) => (
        <div className={classNames('mt-6 pb-4', border && 'border-b border-gray-300', className)}>
          <DisclosureButton className="mb-4 w-full flex justify-between font-semibold text-lg">
            <Text
              as="h3"
              textType="lg"
              {...titleOptions}
              className={classNames('flex gap-2 items-center', titleOptions?.className)}
            >
              {icon} {title} {activeFilters > 0 && <Badge text={activeFilters} variant="DANGER" />}
            </Text>
            <IconFa className="text-sm" icon={['far', open ? 'chevron-up' : 'chevron-down']} />
          </DisclosureButton>
          <DisclosurePanel>
            <div className="bg-gray-50 rounded-xs p-4">{children}</div>
          </DisclosurePanel>
        </div>
      )}
    </Disclosure>
  )
}
